import merge from 'lodash/merge';
import { AddressElement, AddressElementProps } from '@stripe/react-stripe-js';
import Column from '@sdk/components/ui/spacing/Column';
import useConfig from '@sdk/config/useConfig';
import { StripeAddressElementChangeEvent } from '@stripe/stripe-js';

import { useBillingInfo } from '@web/account/billing/BillingInfoContext';
import { PURCHASE_ALLOWED_COUNTRIES } from '@web/account/constants';
import { mapBillingAddressToFormValues } from '@web/account/utils/mappers';

type Props = {
  onChange: (event: StripeAddressElementChangeEvent) => void;
  addressProps?: AddressElementProps;
};

export const BillingAddressForm = ({ onChange, addressProps: overrideAddressProps }: Props) => {
  const {
    billingInfo: { billingAddress },
  } = useBillingInfo();
  const { FEATURE_FLAGS } = useConfig();

  if (!FEATURE_FLAGS.TAX_CALCULATIONS_ENABLED) {
    return null;
  }

  const defaultAddressProps: AddressElementProps = {
    options: {
      defaultValues: mapBillingAddressToFormValues(billingAddress) || undefined,
      mode: 'billing',
      allowedCountries: PURCHASE_ALLOWED_COUNTRIES,
    },
  };
  const addressProps = merge(defaultAddressProps, overrideAddressProps);

  return (
    <Column mTop={10}>
      <AddressElement onChange={onChange} {...addressProps} />
    </Column>
  );
};
